$.fn.assignTester = function () {
  function isInAssignTesterPage() {
    return $("#assign-to-tester").length > 0;
  }

  function updateSubmitButton() {
    if (
      $("#selectRole").val() != "default" &&
      $("#assignedToUserId").val() != "" &&
      $("#assignedToUserId").val() != null &&
      $("#expectedCompletionDate").val() != ""
    ) {
      $("#submit").attr("disabled", false);
    } else {
      $("#submit").attr("disabled", true);
    }
  }

  var $self = $(this);

  if (isInAssignTesterPage()) {
    $("#selectRole").on("change", function (event) {
      event.preventDefault();
      updateSubmitButton();
    });

    $("#assignedToUserId").on("change", function (event) {
      event.preventDefault();
      updateSubmitButton();
    });

    $("#expectedCompletionDate")
      .datepicker({
        onSelect: function () {
          updateSubmitButton();
        },
      })
      .on("change", function () {
        updateSubmitButton();
      });
  }
};
